<template>
  <b-container fluid style="margin-top:90px;">
    <b-card v-if="loading" style="margin-top:90px;" class="text-center">
      <b-spinner label="Loading..."></b-spinner>
    </b-card>

    <b-card v-if="!loading">
      <b-card-text>{{$t("CLASS")}}: {{classname}}</b-card-text>
    </b-card>

    <b-card v-if="!loading" class="mt-1">
      <b-table striped outlined hover :items="students" :fields="fields">
        <template #cell(deletekey)="data">
          <RemStudentFromClassBtn
            v-on:removeStudent="removeStudent"
            :ClassID="classId"
            :StudentID="data.item.ID"
            :token="token"
          />
        </template>
      </b-table>
    </b-card>

    <b-card v-if="!loading" class="mt-1">
      <b-form inline @submit="addStudent">
        <b-form-group :label="$t('SELECT_STUDENT')" label-for="studentinput">
          <b-form-select
            v-model="selectedStudent"
            :options="totalstudents"
            class="mb-2 mr-sm-2 ml-sm-2 mb-sm-0"
            id="studentinput"
          ></b-form-select>
          <b-button type="submit" variant="primary" class="mb-2 mr-sm-2 mb-sm-0">{{$t("ADD_TO_CLASS")}}</b-button>
        </b-form-group>
      </b-form>
    </b-card>
  </b-container>
</template>
<script>
import RemStudentFromClassBtn from "./RemStudentFromClassBtn";
import { ajaxGet, ajaxPost } from "../../ajax";
import {apiUrl} from "@/main";


export default {
  components: {
    RemStudentFromClassBtn
  },
  props: ["classId", "token"],
  data: function() {
    return {
      loading: true,
      students: [],
      fields: [
        { key: "ID", label: this.$t("ID") }, 
        { key: "Username", label: this.$t('USERNAME') }, 
        { key: "deletekey", label: "" }
      ],
      classname: "",
      totalstudents: [],
      selectedStudent: null
    };
  },
  mounted: function() {
    //get students

    //get tenant/me for seat info
    var ceditPnl = this;
    setTimeout(function() {
      ajaxGet(
        apiUrl() +"/classes/" +
          ceditPnl.classId +
          "/students",
        ceditPnl.dataSuccessLoad,
        ceditPnl.dataError,
        ceditPnl.token
      );

      ajaxGet(
        apiUrl() + "/classes/" +
          ceditPnl.classId,
        ceditPnl.dataClassSuccessLoad,
        ceditPnl.dataError,
        ceditPnl.token
      );
    }, 50);

  setTimeout(function() {
      ajaxGet(
        apiUrl() + "/tenants/me/students",
        ceditPnl.dataStudentsSuccessLoad,
        ceditPnl.dataError,
        ceditPnl.token
      );
  }, 250);

    //window.alert(this.token.token);
  },
  methods: {
    addStudent: function(event) {
      event.preventDefault();

      ajaxPost(
        apiUrl() + "/classes/" +
          this.classId +
          "/students",
        { studentId: this.selectedStudent },
        this.addStudentSuccess,
        this.dataError,
        this.token
      );
    },
    addStudentSuccess: function() {
      for (var a = 0; a < this.totalstudents.length; a++) {
        if (this.totalstudents[a].ID == this.selectedStudent) {
          this.students.push(this.totalstudents[a]);
          this.$bvToast.toast(
            this.totalstudents[a].Firstname +
              " " +
              this.totalstudents[a].Lastname +
              " was added to the class!",
            { autoHideDelay: 5000, appendToast: true }
          );
          break;
        }
      }
    },
    dataSuccessLoad: function(res) {
      this.students = res;
      this.loading = false;
    },
    dataClassSuccessLoad: function(res) {
      this.classname = res.Name;
    },
    dataStudentsSuccessLoad: function(res) {
      for (var a = 0; a < res.length; a++) {
        res[a].value = parseInt(res[a].ID);
        res[a].text = res[a].Firstname + " " + res[a].Lastname;
      }

      var trimmedList = []

      for(var b = 0; b < res.length; b++) {
        let wasFound = false;

        for(var c = 0; c < this.students.length; c++) {
          if(parseInt(res[b].ID) == this.students[c].ID) {
            wasFound = true;
            break;
          }
        }

        if(!wasFound)
          trimmedList.push(res[b]);
      }

      this.totalstudents = trimmedList;
    },
    dataError: function(status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }

      this.loading = false;
    },
    removeStudent: function(studentID) {
      var sID = parseInt(studentID);
      for (var a = 0; a < this.students.length; a++) {
        if (sID == parseInt(this.students[a].ID)) {
          this.$bvToast.toast(
            this.students[a].Username + " was removed from the class!",
            { autoHideDelay: 5000, appendToast: true }
          );

          this.students.splice(a, 1);
          break;
        }
      }
    }
  }
};
</script>